import { api } from './Api';
import { portalGeneration, requirePortalAccess } from './PortalSession';

export const QUEUE_TYPES = {
  doordash_exception: 'DoorDash exception',
  need_driver: 'Need driver',
  not_accepted: 'Not accepted',
  not_confirmed: 'Not confirmed',
  late_arrival: 'Late arrival',
  late_pick_up: 'Late pickup',
  late_drop_off: 'Late dropoff',
};
const positive = (v) => Number.isSafeInteger(v) && v > 0;
const context = (v) => v && typeof v.scope_epoch === 'string' && /^[a-f0-9]{48}$/.test(v.scope_epoch) &&
  Number.isFinite(Date.parse(v.server_time_utc));
const object = (v) => v != null && typeof v === 'object' && !Array.isArray(v);
export function validateQueue(page) {
  if (!context(page) || !Array.isArray(page.results) || !Array.isArray(page.business_calendar) ||
      !Array.isArray(page.diagnostic_orders) ||
      !['affected_order_count', 'issue_count', 'diagnostic_order_count'].every((k) =>
        Number.isSafeInteger(page[k]) && page[k] >= 0) ||
      !positive(page.page) || page.page > 1000 || !positive(page.limit) || page.limit > 100 ||
      typeof page.has_more !== 'boolean' ||
      page.business_calendar.some((b) => !b || !positive(b.business_id) ||
        !(b.reason === null || typeof b.reason === 'string')) ||
      page.diagnostic_orders.some((d) => !d || !positive(d.order_id) || !positive(d.business_id) ||
        !object(d.evaluation) || Object.values(d.evaluation).some((v) => typeof v !== 'string')) ||
      page.results.length > page.limit || page.results.some((group) => !group ||
        !positive(group.order_id) || !positive(group.business_id) || !Array.isArray(group.issues) ||
        !page.business_calendar.some((b) => b.business_id === group.business_id && b.reason === null &&
          typeof b.today === 'string' && typeof b.timezone === 'string') ||
        group.issue_count !== group.issues.length ||
        !group.issues.length || group.issues.some((issue) => !issue ||
          !positive(issue.id) || !positive(issue.restaurant_id) ||
          !['routine', 'doordash'].includes(issue.source) ||
          issue.alert_id !== `${issue.source}:${issue.id}` ||
          !Object.prototype.hasOwnProperty.call(QUEUE_TYPES, issue.event_type) ||
          (issue.source === 'doordash') !== (issue.event_type === 'doordash_exception') ||
          !['critical', 'warning'].includes(issue.severity) ||
          !(issue.evidence === null || object(issue.evidence)) ||
          issue.resolved_at !== null || issue.order_id !== group.order_id ||
          issue.business_id !== group.business_id))) {
    throw new Error('Invalid dispatcher queue');
  }
  return page;
}
async function request(work) {
  requirePortalAccess();
  const generation = portalGeneration();
  const result = await work();
  requirePortalAccess();
  if (generation !== portalGeneration()) throw new Error('Alert session expired');
  return result;
}
export const getDispatcherQueue = (filters, signal) => request(async () => {
  const params = { page: 1, limit: 50 };
  ['business_id', 'order_id', 'restaurant_id', 'event_type', 'severity', 'acknowledged', 'page'].forEach((key) => {
    if (filters[key] !== '' && filters[key] != null) params[key] = filters[key];
  });
  const result = validateQueue(await api.get('/deliveryops/alerts', params, { cache: 'no-store', signal }));
  if (result.page !== Number(params.page)) throw new Error('Unexpected alert page');
  return result;
});
export const getDispatcherAlert = (issue, acknowledge = false) => request(async () => {
  if (!/^(routine|doordash):[1-9]\d*$/.test(issue.alert_id)) throw new Error('Invalid alert ID');
  const path = `/deliveryops/alerts/${encodeURIComponent(issue.alert_id)}`;
  const result = await (acknowledge
    ? api.post(`${path}/acknowledge`, undefined, { cache: 'no-store' })
    : api.get(path, undefined, { cache: 'no-store' }));
  if (!context(result) || result.alert_id !== issue.alert_id ||
      result.order_id !== issue.order_id || result.business_id !== issue.business_id) {
    throw new Error('Alert scope mismatch');
  }
  return result;
});
